import React from "react"
import { Icon } from "Shared/Components/Icon/Style";
import { Input } from "Shared/Components/Formfields";
import { SearchStyle } from "./Style";

export const Searchfield = (props: {
    placeholder?: string;
    onSearch: (value: string) => void;
    defaultValue?: string;
    disabled?: boolean;
}) => {
    const [searchValue, setSearchValue] = React.useState("");

    return (
        <SearchStyle.Form>
            <Input
                name={"searchfield"}
                placeholder={props.placeholder}
                onChange={(e) => setSearchValue(e.target.value)}
                defaultValue={props.defaultValue}
            />
            <SearchStyle.Button
                type={"button"}
                onClick={() => props.onSearch(searchValue)}
            >
                <Icon.Lupe isBold />
            </SearchStyle.Button>
        </SearchStyle.Form>
    )
}